import { ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { CanColor, mixinColor } from '@angular/material/core';
import { MatSelectionListChange } from '@angular/material/list';
import { Constructor } from '@mtna/core-ts';
import { DocumentOptionSet } from '@rds/rds-packaging-ts';

export class RdsDocumentOptionSetSelectionEvent {
  /**
   * @param selected Whether the document is selected
   * @param documentOptionSet The document option set
   */
  constructor(public selected: boolean, public documentOptionSet: DocumentOptionSet) {}
}

export class RdsDocumentSelectionBase {
  constructor(public _elementRef: ElementRef) {}
}

export const _RdsDocumentSelectionMixinBase: Constructor<CanColor> & typeof RdsDocumentSelectionBase = mixinColor(
  RdsDocumentSelectionBase,
  'primary'
);

/**
 * A list of packaging format bundles.
 * Each list item can be clicked in order to build up a list of desired bundles.
 *
 * @author Will Davis <will.davis@mtna.us>
 */
@Component({
  selector: 'rds-c-document-selection-list',
  templateUrl: './document-selection-list.component.html',
  styleUrls: ['./document-selection-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class RdsDocumentSelectionListComponent extends _RdsDocumentSelectionMixinBase implements CanColor {
  /** Bundles to display in the list */
  @Input() documentOptionSets: Array<DocumentOptionSet> = [];
  /** Theme color, defaults to primary */
  @Input() color: 'primary' | 'accent' = 'primary';
  /** Selected bundles */
  @Input() selected: Array<DocumentOptionSet> = [];
  /** Emitted when a bundle is selected or unselected */
  @Output() selectionChange = new EventEmitter<RdsDocumentOptionSetSelectionEvent>();

  constructor(_elementRef: ElementRef) {
    super(_elementRef);
  }

  handleSelectionChange(event: MatSelectionListChange) {
    this.selectionChange.emit(new RdsDocumentOptionSetSelectionEvent(event.option.selected, event.option.value));
  }

  _compareWithDocumentOptionSets(o1: DocumentOptionSet, o2: DocumentOptionSet) {
    if (!o1 || !o2) {
      return false;
    }
    return o1.document.uri === o2.document.uri;
  }
}
